<template>
  <a-card :bordered="false">
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :label-col="labelCol1" :wrapper-col="wrapperCol1" :rules="validatorRules"
        slot="detail">
        <a-row>
          <!-- 场馆代码 -->
          <a-col :span="24">
            <a-form-model-item :label="language['cs.venuecode']" prop="venuecode">
              <a-input v-model="model.venuecode" :placeholder="'系统自动生成'" :disabled="true"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <!-- 场馆名称 -->
            <a-form-model-item :label="language['cs.venuename']" prop="venuename">
              <a-input v-model="model.venuename" :placeholder="this.language['cs.venuename']" :maxLength="100"></a-input>
            </a-form-model-item>
          </a-col>
          <!-- 场馆状态 -->

          <a-col :span="24">
            <a-form-model-item :label="language['cs.venuestatus']" prop="status">
              <j-dict-select-tag type="select" v-model="model.status" dictCode="cs_venuestatus" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <!-- 场馆性质 -->
            <a-form-model-item :label="language['cs.venuecategory']" prop="category">
              <j-dict-select-tag type="select" v-model="model.category" dictCode="cs_venuecategory" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <!-- 场馆地址 -->
            <a-form-model-item :label="language['labor.contractor.detailAddress']" :labelCol="labelCol1"
              :wrapperCol="wrapperCol1" prop="address">
              <a-input v-model="model.address" :placeholder="this.language['labor.contractor.detailAddress']" :maxLength="500"></a-input>
            </a-form-model-item>
          </a-col> </a-row>
        <a-row>
          <a-col :span="24">
            <!-- 上傳附件圖片 -->
            <a-form-model-item :label="this.language['common.uploadPicture']" :labelCol="labelCol1"
              :wrapperCol="wrapperCol1" prop="files">
              <j-image-upload class="avatar-uploader" text="上传"  v-model="model.files"
                :isMultiple="true" :disabled="disableSubmit"></j-image-upload>
            </a-form-model-item>
          </a-col> </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</a-card>
</template>
  
  
<script>

import { httpAction, getAction } from '@/api/manageChooseSeat'
import { validateDuplicateValue,hasValue} from '@/utils/util'
import { queryAreaIdTree } from '@/api/api'
import LanguageModel from "@/components/LanguageModel"
import { FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormModelAndTables } from '@/utils/JEditableTableUtil'
import { JEditableTableModelMixin } from '@/views/chooseSeat/mixins/JEditableTableModelMixin'

import moment from 'moment'

export default {
  name: 'VenueForm',
  components: {},
  props: {
    //表单禁用
    parent: {
      type: Object,
      default: {}
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {},
      // form 一行布局
      uploadSource:"chooseseat",
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },
      confirmLoading: false,
      url: {
        add: "/venueinfo/addData",
        edit: "/venueinfo/editData",
      },
      selectActivityList: [],
      selectPgList: [],
      selectVenueList: []
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      if (this.language) {
        return {
          venuename: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.venuename'] },
          ],
          status: [
            { required: true, message: this.language['common.select'] + this.language['cs.venuestatus'] },
          ],
          category: [
            { required: true, message: this.language['common.select'] + this.language['cs.venuecategory'] },
          ],
          address: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['labor.contractor.detailAddress'] },
          ],
        }
      }
    }

  },
  created() {
    //备份model原始值
    // this.modelDefault = JSON.parse(JSON.stringify(this.model));
    // this.loadSelectData();
  },
  mounted() {
  },
  watch: {

  },
  methods: {

    add() {
      // this.edit(this.modelDefault);
      this.visible = true;
    },
    edit(record) {
      this.model = Object.assign({}, record);
      this.visible = true;
    },

    submitForm() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate(valid => {

        if (valid) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!that.model.sysvenueid) {
            httpurl += that.url.add;
            method = 'post';
          } else {
            httpurl += that.url.edit;
            method = 'put';
          }
          httpAction(httpurl, that.model, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok',that.model);
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }

      })
    },

    // clearValidate(){
    //     this.$nextTick(()=>{
    //       this.$refs['form'].clearValidate()
    //     })
    //   }

  }
}


</script>